var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_864_485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_864_485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 11.9997C5.14444 11.9997 4.986 11.9357 4.858 11.8077C4.73044 11.6801 4.66667 11.5219 4.66667 11.333V4.66634C4.66667 4.47745 4.73044 4.31901 4.858 4.19101C4.986 4.06345 5.14444 3.99967 5.33333 3.99967C5.52222 3.99967 5.68067 4.06345 5.80867 4.19101C5.93622 4.31901 6 4.47745 6 4.66634V11.333C6 11.5219 5.93622 11.6801 5.80867 11.8077C5.68067 11.9357 5.52222 11.9997 5.33333 11.9997ZM8 14.6663C7.81111 14.6663 7.65289 14.6023 7.52533 14.4743C7.39733 14.3468 7.33333 14.1886 7.33333 13.9997V1.99967C7.33333 1.81079 7.39733 1.65234 7.52533 1.52434C7.65289 1.39679 7.81111 1.33301 8 1.33301C8.18889 1.33301 8.34733 1.39679 8.47533 1.52434C8.60289 1.65234 8.66667 1.81079 8.66667 1.99967V13.9997C8.66667 14.1886 8.60289 14.3468 8.47533 14.4743C8.34733 14.6023 8.18889 14.6663 8 14.6663ZM2.66667 9.33301C2.47778 9.33301 2.31956 9.26901 2.192 9.14101C2.064 9.01345 2 8.85523 2 8.66634V7.33301C2 7.14412 2.064 6.98567 2.192 6.85767C2.31956 6.73012 2.47778 6.66634 2.66667 6.66634C2.85556 6.66634 3.014 6.73012 3.142 6.85767C3.26956 6.98567 3.33333 7.14412 3.33333 7.33301V8.66634C3.33333 8.85523 3.26956 9.01345 3.142 9.14101C3.014 9.26901 2.85556 9.33301 2.66667 9.33301ZM10.6667 11.9997C10.4778 11.9997 10.3196 11.9357 10.192 11.8077C10.064 11.6801 10 11.5219 10 11.333V4.66634C10 4.47745 10.064 4.31901 10.192 4.19101C10.3196 4.06345 10.4778 3.99967 10.6667 3.99967C10.8556 3.99967 11.0138 4.06345 11.1413 4.19101C11.2693 4.31901 11.3333 4.47745 11.3333 4.66634V11.333C11.3333 11.5219 11.2693 11.6801 11.1413 11.8077C11.0138 11.9357 10.8556 11.9997 10.6667 11.9997ZM13.3333 9.33301C13.1444 9.33301 12.9862 9.26901 12.8587 9.14101C12.7307 9.01345 12.6667 8.85523 12.6667 8.66634V7.33301C12.6667 7.14412 12.7307 6.98567 12.8587 6.85767C12.9862 6.73012 13.1444 6.66634 13.3333 6.66634C13.5222 6.66634 13.6804 6.73012 13.808 6.85767C13.936 6.98567 14 7.14412 14 7.33301V8.66634C14 8.85523 13.936 9.01345 13.808 9.14101C13.6804 9.26901 13.5222 9.33301 13.3333 9.33301Z",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoice);
export default __webpack_public_path__ + "static/media/voice.eba86dcfb1316631f976390492fe3dfc.svg";
export { ForwardRef as ReactComponent };